import { Button, ButtonProps } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { ImportOutlined } from '@ant-design/icons';

interface Props extends ButtonProps {}
export default function ImportBtn(props: Props) {
  const { t } = useTranslation();
  return (
    <Button icon={<ImportOutlined />} type="primary" {...props}>
      {t('Import')}
    </Button>
  );
}
